import { BellRing, X } from "lucide-react";

export const AlertBanner = ({ alert, onDismiss, onFocus }) => {
  if (!alert) return null;
  const buy = alert.type === "BUY";
  return <div className={`alert-banner ${buy ? "buy" : "sell"}`} data-testid="signal-alert-banner" role="alert">
    <BellRing size={18} className="ring" />
    <b data-testid="signal-alert-text">{alert.type} ALERT · {alert.symbol} @ ₹{alert.price.toFixed(2)}</b>
    <span>{alert.time} IST · strength {alert.strength}% · {alert.reason}</span>
    <button className="ab-view" data-testid="signal-alert-view-button" onClick={() => onFocus(alert.symbol)}>Show chart</button>
    <button className="ab-x" data-testid="signal-alert-dismiss-button" onClick={onDismiss} aria-label="Dismiss alert"><X size={16} /></button>
  </div>;
};
